export default class MeetingModalityDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static get physical() {
        return {
            id: 1,
        };
    }
    static get phone() {
        return {
            id: 2,
        };
    }
    static get online() {
        return {
            id: 3,
        };
    }
}
